export const createStyles = (theme: any) => ({
  comment: { display: 'flex', flexDirection: 'column', gap: 1 },
  commentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    minWidth: 0,
  },
  authorRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
    flex: 1,
  },
  avatarContainer: { pt: 1, width: 40, height: 48, flexShrink: 0 },
  avatarPresenceWrapper: { position: 'relative', width: 40, height: 40 },
  avatar: { width: 40, height: 40, cursor: 'default' },
  onlineBadge: {
    position: 'absolute',
    width: 12,
    height: 12,
    right: -2,
    bottom: -2,
    background: theme.palette.background.paper,
    borderRadius: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
    '&::after': {
      content: '""',
      width: 8,
      height: 8,
      background: '#2E7D32',
      borderRadius: '100px',
    },
  },
  authorDetails: {
    minWidth: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  authorNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    minWidth: 0,
    overflow: 'hidden',
  },
  authorName: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1.5,
    display: 'block',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  educatorBadge: {
    flexShrink: 0,
    cursor: 'default',
    '& *': { cursor: 'default !important' },
  },
  educatorChip: {
    height: 24,
    color:
      theme.palette.mode === 'dark'
        ? '#005B6C'
        : theme.palette.primary.contrastText,
    backgroundColor: theme.palette.mode === 'dark' ? '#B4E8FB' : '#027D99',
    '& .MuiChip-label': { px: 0.75, fontSize: '0.8125rem' },
  },
  date: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.43,
  },
  moreIcon: {
    fontSize: 24,
    color: theme.palette.text.secondary,
  },
  moreButton: {
    mt: -0.5,
    ml: 1,
    '&:hover': { background: theme.palette.action.hover },
  },
  commentMenu: (isDark: boolean) => ({
    '& .MuiPaper-root': {
      width: 120,
      color: isDark ? '#ffffff' : undefined,
      ...(isDark && { background: '#363636' }),
    },
  }),
  commentContent: {
    pl: 6,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.9375rem',
    lineHeight: 1.6,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    '& p': { m: 0 },
    '& *': {
      maxWidth: '100%',
      fontFamily: `${theme.typography.fontFamily} !important`,
    },
    '& [data-testid="code-block"] *': { fontFamily: 'monospace !important' },
    '& .katex, & .katex *': { fontFamily: 'KaTeX_Main, serif !important' },
  },
  reactions: {
    pl: 6,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
    color: theme.palette.text.secondary,
  },
  reactionSpacer: { width: 8 },
  replyAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 32,
    minHeight: 32,
    px: 1,
    gap: 0.5,
    border: 0,
    borderRadius: 1,
    background: 'transparent',
    cursor: 'pointer',
    '&:hover': { backgroundColor: theme.palette.action.hover },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  replyIcon: {
    width: 24,
    height: 24,
    color:
      theme.palette.mode === 'dark'
        ? 'rgba(248, 247, 249, 0.56)'
        : 'rgba(35, 31, 41, 0.56)',
  },
  replyLabel: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.16px',
    color: theme.palette.text.primary,
  },
  replyEditor: {
    pl: { xs: 0, md: 6 },
    mt: 1,
    minWidth: 0,
  },
  replies: { display: 'flex', flexDirection: 'column', gap: 2, mt: 1 },
  reply: {
    px: { xs: 2, md: 6 },
    mt: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  root: { display: 'flex', flexDirection: 'column' },
  toggleButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    width: '100%',
    height: 40,
    px: 2,
    border: 0,
    borderRadius: `${theme.shape?.borderRadius ?? 4}px`,
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    fontFamily: theme.typography.fontFamily,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    '&:hover': { background: theme.palette.action.hover },
  },
  toggleIcon: (expanded: boolean) => ({
    transition: 'transform 0.2s',
    transform: expanded ? 'rotate(180deg)' : 'none',
  }),
  comments: { display: 'flex', flexDirection: 'column', gap: 2, mt: 4 },
  previousCommentsButton: {
    alignSelf: 'stretch',
    width: '100%',
    mb: 3,
    p: 0,
    border: 0,
    background: 'transparent',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.875rem',
    fontWeight: theme.typography.fontWeightMedium,
  },
  commentWrapper: (isLast: boolean) => ({
    pb: isLast ? 0 : 2,
    borderBottom: isLast ? 0 : `1px solid ${theme.palette.divider}`,
  }),
  addComment: (hasComments: boolean) => ({
    mt: hasComments ? '12px' : 0,
    minWidth: 0,
  }),
});
